import React from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

import { OrgChart } from '../../types';
import Spinner from '../../components/Spinner';
import { useFlipOIDC } from '../../components/FlipOIDC';
import Parents from './Parents';
import Active from './Active';

import './styles.css';

export default function Viewer() {
  const { me, token } = useFlipOIDC();

  const [loading, setLoading] = React.useState(true);
  const [active, setActive] = React.useState<string>(me.user_id);
  const [data, setData] = React.useState<undefined | OrgChart>();

  const load = React.useCallback(async () => {
    try {
      const { data: orgchart } = await axios.get<OrgChart>('/api/v2/orgchart', { headers: { Authorization: `Bearer ${token}` } });
      setData(orgchart);
      setLoading(false);
    } catch (err) {
      toast.error('Error loading Org Chart data. The Flip API changed, so I need to find a work around.');
    }
  }, [token]);

  React.useEffect(() => {
    load();
  }, [load]);

  const handleClick = (id: string) => {
    setActive(id);
  };

  if (loading) {
    return (
      <Spinner fullPage />
    );
  }

  return (
    <div className="orgchart">
      <Parents active={active} value={data} onClick={handleClick} />
      <Active active={active} value={data} onClick={handleClick} />
    </div>
  );
}
